
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "26e2efd11a4d0069511e4e82ec32b13c19b9360b",
  "nuxt": {
    "buildId": "ab68fe6a-67d0-4d4e-9f1a-0cb60307ea7a"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
